module.exports = __webpack_public_path__ + "static/media/soraka.2e7c2a17.png";